module.exports = __webpack_public_path__ + "img/product-preview-26.e519f43.png";